import { render, staticRenderFns } from "./channelReport.vue?vue&type=template&id=45c1e519&"
import script from "./channelReport.vue?vue&type=script&lang=js&"
export * from "./channelReport.vue?vue&type=script&lang=js&"
import style0 from "./channelReport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports